const validate = values => {
  const errors = {}

  if (!values.leaderboard_form?.mobile_app_usage) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      mobile_app_usage: "The points are required",
    }
  }

  if (!values.leaderboard_form?.media_posted) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      media_posted: "The points are required",
    }
  }

  if (!values.leaderboard_form?.poll_taken) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      poll_taken: "The points are required",
    }
  }

  if (!values.leaderboard_form?.survey_taken) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      survey_taken: "The points are required",
    }
  }

  if (!values.leaderboard_form?.trivia_right_answer) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      trivia_right_answer: "The points are required",
    }
  }

  if (!values.leaderboard_form?.document_opened) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      document_opened: "The points are required",
    }
  }

  if (!values.leaderboard_form?.web_link_accessed) {
    errors.leaderboard_form = {
      ...errors.leaderboard_form,
      web_link_accessed: "The points are required",
    }
  }
  return errors
}

export default validate
